<template>
    <v-form ref="form" v-if="item" @focusout.native="onFieldCommit">
        <v-card-title>{{ item.name }}
            <v-spacer></v-spacer>
        </v-card-title>
        <template v-if="item && !['TOOL_FOLDER'].includes(item.class)">
            <v-card-text>
                <!-- verplichte-velden-feedback via $toaster.notify (zie saveItem) -->
            <v-row class="mb-4">
                <v-col>
                    <v-row>
                    <v-col cols="12" :xl="6">
                        <eod-text-field
                            v-model="item.name"
                            :rules="[val => $validator.required(val, 'Naam')]"
                            label="Naam*"
                            required
                            outlined
                            hide-details
                            dense
                        ></eod-text-field>
                    </v-col>
                    <v-col cols="12" :xl="6">
                        <eod-text-field
                            v-model="item.description"
                            label="Omschrijving"
                            outlined
                            hide-details
                            dense
                        ></eod-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" :xl="6">
                        <eod-object-autocomplete dense hide-details :rules="[val => $validator.required(val, 'Type')]" label="Type*" endpoint="toolTypes" v-model="item.toolType.id" required>
                            <template v-slot:append-item>
                                <v-divider></v-divider>
                                <v-list-item dense @click="isCreateTypeDialogVisible = true">
                                    <v-list-item-icon>
                                        <v-icon>mdi-plus</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Type toevoegen</v-list-item-title>
                                        <v-list-item-subtitle>Voeg een type toe wanneer u deze
                                            niet in de lijst vindt.</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </eod-object-autocomplete>
                        <eod-dialog title="Type toevoegen" icon="mdi-plus" iconColor="primary" v-if="isCreateTypeDialogVisible" v-model="isCreateTypeDialogVisible" @okAction="createToolType" okText="Toevoegen">
                            <v-form ref="toolTypeForm">
                                <v-alert type="error" v-if="typeFormErrors[0]" dense class="mt-2">
                                    <ul>
                                        <li v-for="(error, index) in typeFormErrors" :key="index">{{ error }}</li>
                                    </ul>
                                </v-alert>
                                <eod-tool-type-detail class="mt-4" v-model="newToolType"></eod-tool-type-detail>
                            </v-form>
                        </eod-dialog>
                    </v-col>
                    <v-col cols="12" :xl="6">
                        <eod-objects-treeview-input :classes="['DEPOT', item.class+'_FOLDER', item.class]" :rules="[val => $validator.required(val, 'Bovenliggend item')]" required v-model="item.treeParentId" :exclude="item.id?[item.id]:null" label="Bovenliggend item*"></eod-objects-treeview-input>
                    </v-col>
                </v-row>
                <v-row v-if="item.toolType && item.toolType.id">
                    <v-col>                        
                        <eod-product-type-preview :value="item.toolType.id"></eod-product-type-preview>
                    </v-col>
                </v-row>
                </v-col>
                <v-col cols="12" :lg="'auto'">
                    <v-img width="200" max-height="280" :src="qr_code" aspect-ratio="1" contain />
                </v-col>
            </v-row>
    </v-card-text>
</template>
    <v-card-text v-else-if="['TOOL_FOLDER'].includes(item.class)">
        <v-text-field label="Naam" dense outlined v-model="item.name"></v-text-field>
    </v-card-text>
</v-form>
</template>
<script>
import QRCode from 'qrcode'
import eodObjectAutocomplete from './eod-object-autocomplete.vue';
import eodObjectsTreeviewInput from './eod-objects-treeview-input.vue';
import eodProductTypePreview from './eod-product-type-preview.vue';
import eodToolTypeDetail from './eod-tool-type-detail.vue';
import Tool from './../models/tool.js';

export default{
    name: 'eod-tool-detail',
    components:{
        eodObjectAutocomplete,
        eodObjectsTreeviewInput,
        eodProductTypePreview,
        eodToolTypeDetail
    },
    props:{
        value: String|Object
    },
    data: () => ({
        item: null,
        loading: false,
        savingTimeout: null,
        creating: false,
        saving: false,
        isSaveAlertVisible: false,
        isSavedSnackbarVisible: false,
        errors: null,
        missingFieldsToast: null,
        selectedtab: 'general',
        qr_code: null,
        isCreateTypeDialogVisible: false,
        newToolType: {},
        typeFormErrors: [],
    }),
    created(){
        if(this.value){
            if(typeof this.value == 'string'){
                this.loading = true;
                
                this.$eod.getById('tool', this.value, ['id', 'name', 'treeParentId', 'description', 'toolType{id}', 'class'])
                    .then(response => {
                        if(response && response.data.data && response.data.data.tool){
                            this.item = new Tool(response.data.data.tool);
                        }else{
                            this.item = null;
                        }
                    }).finally(() => {
                        this.loading=false;
                    });
            }else{
                this.item = this.value
            }
        }
        

        // QR code
        QRCode.toDataURL(window.location.href).then(result => {
            this.qr_code = result;
        });
    },
    watch:{
        loading(val){
            this.$emit('loading', val);
        },
        item: {
            deep: true,
            handler() {
                // Autosave: stil valideren (geen inline rode meldingen), debounced.
                if (this.$refs.form) { this.$refs.form.resetValidation(); }
                clearTimeout(this.savingTimeout);
                if (this.loading) { return; }
                // Nieuw item niet tijdens het typen aanmaken (voorkomt meerdere
                // onvolledige duplicaten, #297): pas createn op een commit-moment
                // (focusout, zie onFieldCommit) of — als vangnet — na langere
                // inactiviteit. Bestaande items autosaven wél meteen (update).
                const isNew = !this.item.id;
                this.savingTimeout = setTimeout(
                    () => (isNew ? this.onFieldCommit() : this.saveItem(false)),
                    isNew ? 2500 : 500,
                );
            }
        }
    },
    methods:{
        createToolType(){
            if(this.$refs.toolTypeForm){
                const valid = this.$refs.toolTypeForm.validate();

                if(!valid){
                    this.typeFormErrors = [];
                    this.$refs.toolTypeForm.inputs.forEach(e => {
                        if (e.errorBucket && e.errorBucket.length) {
                            this.typeFormErrors.push(...e.errorBucket);
                        }
                    });

                    return false;
                }

                this.$eod.save('ToolType', this.newToolType).then((response) => {
                    if(response.data && response.data.data && response.data.data.createToolType){
                        this.item.toolType = response.data.data.createToolType;
                        this.isCreateTypeDialogVisible = false;
                        this.newToolType = {};
                    }
                });
            }
        },
        getFormErrors() {
            const errors = [];
            this.$refs.form.inputs.forEach(e => {
                if (e.errorBucket && e.errorBucket.length) {
                    errors.push(...e.errorBucket);
                }
            });
            return errors;
        },
        onFieldCommit() {
            // Commit-moment voor een nog niet aangemaakt item: veld verlaten (blur) of
            // langere pauze. Pas dán aanmaken, en enkel als het formulier geldig is — zo
            // ontstaan er geen tussentijdse, onvolledige duplicaten (#297). Stille check:
            // bij een onvolledig formulier nog niet aanmaken en niet zeuren.
            if (this.loading || this.saving || this.creating) return;
            if (this.item.id || !this.$refs.form) return;
            if (!this.$refs.form.validate()) {
                this.$refs.form.resetValidation();
                return;
            }
            clearTimeout(this.savingTimeout);
            this.saveItem(false);
        },
        saveItem(showInlineErrors = true){
            this.errors = null;
            if(!this.$refs.form){
                return false;
            }

            const validation = this.$refs.form.validate();
            if(!validation){
                const formErrors = this.getFormErrors();
                if(formErrors.length && !this.missingFieldsToast){
                    // Blijft staan tot het formulier geldig is of de gebruiker erop klikt.
                    this.missingFieldsToast = this.$toaster.notify({
                        type: 'danger',
                        timeout: 0,
                        title: 'Gelieve verplichte velden in te vullen',
                        body: formErrors.join('<br>'),
                        onClose: () => { this.missingFieldsToast = null; }
                    });
                }
                if(!showInlineErrors){
                    // Autosave: geen inline rode meldingen die de invulvelden wegduwen.
                    this.$refs.form.resetValidation();
                }
                return false;
            }

            // Voorkom dubbele aanmaak: create al onderweg voor dit nieuwe item → skip.
            const isNew = !this.item.id;
            if(isNew && this.creating){
                return false;
            }
            // Geldig: sluit een eventuele "verplichte velden"-melding meteen; bij een
            // geslaagde opslag komt er een groene bevestiging in de plaats.
            const hadMissingToast = !!this.missingFieldsToast;
            if(this.missingFieldsToast){ this.missingFieldsToast(true); this.missingFieldsToast = null; }

            this.saving = true;
            if(isNew){ this.creating = true; }

            const data = (new Tool(this.item)).getSaveData();
            this.$eod.save('Tool', data)
                .then(response => {
                    if(response && response.data.data){
                        if(response.data.data.createTool){
                            this.item.id = response.data.data.createTool.id;
                            this.$emit('saved', response.data.data.createTool.id);
                            this.$toaster.notify({ type: 'success', title: 'Gereedschap succesvol aangemaakt' });
                        }else if (response.data.data.updateTool){
                            this.item.id = response.data.data.updateTool.id;
                            this.$emit('saved', response.data.data.updateTool.id);
                            // Groene bevestiging enkel na het oplossen van ontbrekende
                            // velden; gewone autosaves blijven stil.
                            if(hadMissingToast){ this.$toaster.notify({ type: 'success', title: 'Gereedschap succesvol aangepast' }); }
                        }
                    }
                })
                .finally(() => {
                    this.saving = false;
                    this.creating = false;
                });
        },
    }
}
</script>